import axios from "axios"
import { CreateLocationQRCodeInterface, GetLocationQRCodeInterface } from "@type/locations.types"
const ROOT_PATH = "locations/qr-code"
export default class LocationQRCodeService {
	static createLocationQRCode = (id: string, locationQRCode: CreateLocationQRCodeInterface) =>
		axios.post<{ data: GetLocationQRCodeInterface[] }>(`${ROOT_PATH}/${id}`, locationQRCode)

	static updateLocationQRCode = (_id: string, locationQRCode: Partial<GetLocationQRCodeInterface>) =>
		axios.put<GetLocationQRCodeInterface>(`${ROOT_PATH}/${_id}`, locationQRCode)

	static deleteLocationQRCode = (_id: string, qrId: string) =>
		axios.put<{ data: GetLocationQRCodeInterface[] }>(`${ROOT_PATH}/qr/delete`, { id: _id, qrId })

	static getLocationQRCodes = (locationId: string) =>
		axios.get<GetLocationQRCodeInterface[]>(`${ROOT_PATH}/${locationId}`)
}
